import { Group, GroupProps, Loader, MantineSize, Text } from "@mantine/core"

export const LoadingIndicator: React.FC<{ resource?: string, overrideText?: string, size?: MantineSize, groupProps?: GroupProps }> = (props) => {

    let text = 'Loading...'
    if (props.overrideText) {
        text = props.overrideText
    } else if (props.resource) {
        text = `Loading ${props.resource}...`
    }

    return (
        <Group p={'lg'} {...props.groupProps}>
            <Loader size={props.size ?? 'xs'} type='bars' />
            <Text c={'dimmed'} size={props.size ?? 'sm'}>{text}</Text>
        </Group>
    )
}